import React from 'react';
import { FormattedMessage } from 'react-intl';

export const CONFIGURE_TEXT = {
    id: 'oe.common.configure',
    defaultMessage: 'Configure',
    description: 'Button text',
};

export const DONE_TEXT = {
    id: 'oe.common.done',
    description: 'Button text',
    defaultMessage: 'Done'
};

export const CANCEL_TEXT = {
    id: 'oe.common.cancel',
    description: 'Button text',
    defaultMessage: 'Cancel',
};

export const REQUIRED_FIELD_TEXT = {
    id: 'oe.common.requiredField',
    defaultMessage: '(Required)',
    description: 'Indicator appended to a form field label when the field is required',
};

export const ERROR_TEXT = {
    id: 'oe.common.error',
    defaultMessage: 'Error',
    description: 'Label text',
};

export const DATE_TEXT = {
    id: 'oe.common.date',
    defaultMessage: 'Date',
    description: 'Label text',
};

export const DATE_AND_TIME_TEXT = {
    id: `oe.common.dateAndTime`,
    description: 'Label text',
    defaultMessage: 'Date & Time',
};

export const APPLY_AND_CLOSE_TEXT = {
    id: 'oe.common.applyAndClose',
    description: 'Button text',
    defaultMessage: 'Apply and Close',
};

export const APPLY_TEXT = {
    id: 'oe.common.apply',
    description: 'Button text',
    defaultMessage: 'Apply',
};

export const ADD_TEXT = {
    id: 'oe.common.add',
    description: 'Button text',
    defaultMessage: 'Add',
};

export const EDIT_TEXT = {
    id: 'oe.common.edit',
    description: 'Button text',
    defaultMessage: 'Edit',
};

export const TOPIC_TEXT = {
    id: `oe.common.topic`,
    description: 'Label text',
    defaultMessage: 'Topic',
};

export const REMOVE_TEXT = {
    id: 'oe.common.remove',
    description: 'Button label',
    defaultMessage: 'Remove',
};

export const REPLACE_TEXT = {
    id: 'oe.common.replace',
    description: 'Button label',
    defaultMessage: 'Replace',
};

export const CONNECTION_DETAILS = {
    id: 'oe.common.connectionDetails',
    description: 'Label text',
    defaultMessage: 'Connection Details',
};

export const CONFIGURE_PASSPORT_DISPLAY_TEXT = {
    id: 'oe.common.configurePassportDisplay',
    description: 'Button text',
    defaultMessage: 'Configure Passport Display',
};

export const PASSPORT_PREVIEW_TEXT = {
    id: 'oe.common.passportPreview',
    description: 'Button text',
    defaultMessage: 'Passport Preview',
};

export const PASSPORT_PREVIEW_CONNECTION_GROUP_TEXT = {
    id: 'oe.common.passportPreviewConnectionGroup',
    description: 'Button text',
    defaultMessage: 'Passport Preview: Connection Group',
};

export const START_DATE_TEXT = {
    description: 'Label text',
    defaultMessage: 'Start Date',
    id: 'oe.common.startDate',
};

export const END_DATE_TEXT = {
    description: 'Label text',
    defaultMessage: 'End Date',
    id: 'oe.common.endDate',
};

export const STAFFING_START_DATE_TEXT = {
    description: 'Label text',
    defaultMessage: 'Staffing Start Date',
    id: 'oe.common.staffingStartDate',
};

export const STAFFING_END_DATE_TEXT = {
    description: 'Label text',
    defaultMessage: 'Staffing End Date',
    id: 'oe.common.staffingEndDate',
};

export const START_TIME_TEXT = {
    id: 'oe.common.startTime',
    defaultMessage: 'Start Time',
    description: 'Label text',
};

export const END_TIME_TEXT = {
    id: 'oe.meeting.endTime',
    defaultMessage: 'End Time',
    description: 'Label text',
};

export const DEFAULT_TEXT = {
    id: 'oe.common.default',
    defaultMessage: 'Default',
    description: 'Label text'
};

export const GROUPS_TEXT = {
    id: 'oe.common.groups',
    description: 'Label text',
    defaultMessage: 'Groups'
};

export const MANAGE_TEXT = {
    id: 'oe.common.manage',
    defaultMessage: 'Manage',
    description: 'Button text',
};

export const submitText = (isEditMode: boolean): React.ReactElement =>
    isEditMode
        ? applyText()
        : addText();

export const applyText = (): React.ReactElement =>
    <FormattedMessage {...APPLY_TEXT} />;

export const addText = (): React.ReactElement =>
    <FormattedMessage {...ADD_TEXT} />;

export const cancelText = (): React.ReactElement =>
    <FormattedMessage {...CANCEL_TEXT} />;

export const editText = (): React.ReactElement =>
    <FormattedMessage {...EDIT_TEXT} />;

export const openText = (): React.ReactElement =>
    <FormattedMessage id='oe.common.open' defaultMessage='Open' description='Button label text' />;

export const errorText = (): React.ReactElement =>
    <FormattedMessage description='Label text' defaultMessage='Error' id='oe.common.error' />;

export const applyAndCloseText = (): React.ReactElement =>
    <FormattedMessage description='Label text' defaultMessage='Apply and Close' id='oe.common.applyAndClose' />;

export const dataIsBeingSavedText = (): React.ReactElement =>
    <FormattedMessage
        description='Label text'
        defaultMessage='Data is being saved, please wait{suffix}'
        id='oe.customFields.dataIsBeingSaved'
        values={{
            suffix: '...'
        }}
    />
    ;

export const loadingText = (): React.ReactElement =>
    <FormattedMessage
        description='Label text'
        defaultMessage='Loading data{suffix}'
        id='oe.common.loadingData'
        values={{
            suffix: '...'
        }}
    />
    ;

export const MORE_BUTTON_TEXT = {
    id: 'oe.common.more',
    description: 'Button text',
    defaultMessage: 'More...',
};

export const LOAD_MORE_BUTTON_TEXT = {
    id: 'oe.common.loadMore',
    description: 'Button text',
    defaultMessage: 'Load More',
};

export const TYPE = {
    id: 'oe.common.type',
    description: 'Label text',
    defaultMessage: 'Type',
};
export const DESCRIPTION = {
    id: 'oe.common.description',
    description: 'Description name title',
    defaultMessage: 'Description'
};

export const LOGO_IMAGE_TEXT = {
    id: 'oe.image.logo',
    defaultMessage: 'Logo image',
    description: 'Label text'
};

export const NAME_TEXT = {
    id: 'oe.common.name',
    description: 'Label text',
    defaultMessage: 'Name',
};

export const MEETINGS_TEXT = {
    id: 'oe.common.meetings',
    defaultMessage: 'Meetings',
    description: 'Label text'
};

export const ROOM_TEXT = {
    id: 'oe.common.room',
    defaultMessage: 'Room',
    description: 'Label text'
};

export const EXTERNAL_ID_TEXT = {
    id: 'oe.common.externalId',
    defaultMessage: 'External ID',
    description: 'Label text'
};

export const EMPTY_SEARCH_RESULT = {
    description: 'Empty search result',
    defaultMessage: 'No results match your search criteria',
    id: 'oe.searchInput.emptySearchResult',
};

export const LOADING = {
    id: 'oe.common.loading',
    defaultMessage: 'Loading{suffix}',
    description: 'Loading placeholder'
};

export const NO_MEETINGS_FOUND = {
    id: 'oe.control.noMeetingsFound',
    description: 'Placeholder for meetings filter popover',
    defaultMessage: 'No meetings found'
};

export const DELETE_TEXT = {
    id: 'oe.common.delete',
    description: 'Label text',
    defaultMessage: 'Delete',
};

export const YES_DELETE_TEXT = {
    id: 'oe.common.yesDelete',
    description: 'Label text',
    defaultMessage: 'Yes, Delete',
};

export const COORDINATORS_TEXT = {
    id: 'oe.common.coordinators',
    description: 'Title text',
    defaultMessage: 'Coordinators'
};

export const EVENT_PUBLIC_DESCRIPTION_TEXT = {
    description: 'Label text',
    defaultMessage: 'Event Public Description',
    id: 'oe.event.publicDescription',
};

export const EVENT_PRIVATE_DESCRIPTION_TEXT = {
    description: 'Label text',
    defaultMessage: 'Event Private Description',
    id: 'oe.event.privateDescription',
};

export const EVENT_THUMBNAIL_IMAGE_TEXT = {
    description: 'Label text',
    defaultMessage: 'Event Thumbnail',
    id: 'oe.event.thumbnailImage',
};

export const EVENT_TITLE_FOR_PASSPORT_TEXT = {
    id: 'oe.website.eventTitleForPassport',
    description: 'Label text',
    defaultMessage: 'Event Title for Passport',
};

export const FORM_UPDATED_TEXT = {
    id: 'oe.common.formUpdated',
    description: 'Label text',
    defaultMessage: 'Form updated',
};

export const BLUEPRINTS_TEXT = {
    id: 'oe.common.blueprints',
    description: 'Label text',
    defaultMessage: 'Event Blueprints'
};

export const ADD_BLUEPRINTS_TEXT = {
    id: 'oe.common.addBlueprints',
    description: 'Label text',
    defaultMessage: '+ Add Event Blueprints'
};

export const SELECT_ALL_TEXT = {
    id: 'oe.common.selectAll',
    description: 'Label text',
    defaultMessage: 'Select all'
};

export const MIN_VALUE_REQUIRED_ERROR_TEXT = {
    id: 'oe.common.atLeastOneValueRequired',
    description: 'Validation error message',
    defaultMessage: 'Atleast 1 value needs to be selected'
};

export const FIRST_NAME_TEXT = {
    id: 'oe.common.firstName',
    defaultMessage: 'First Name',
    description: 'Label text'
};

export const LAST_NAME_TEXT = {
    id: 'oe.common.lastName',
    defaultMessage: 'Last Name',
    description: 'Label text'
};

export const EMAIL_TEXT = {
    id: 'oe.common.email',
    defaultMessage: 'Email',
    description: 'Label text'
};

export const TITLE_TEXT = {
    id: 'oe.common.title',
    defaultMessage: 'Title',
    description: 'Label text'
};